import { motion } from 'framer-motion';
import TopBar from '../components/TopBar';
import Header from '../components/Header';
import Footer from '../components/Footer';

const STATIC_HEADER = { cta_url: '/donate' };
const STATIC_FOOTER = { contact_email: 'info@securethevotemd.com' };

const DataSourceStatementPage = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="data-source-statement-page">
      <TopBar />
      <Header config={STATIC_HEADER} />

      <section className="relative overflow-hidden bg-[#9E1B32] pt-[50px]" data-testid="page-hero">
        <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "url('https://securethevotemd.com/images/2025/03/2025-Feb-25-Secure-the-Vorte-66-1024x683.jpg')", backgroundPosition: 'center', backgroundSize: 'cover' }} />
        <div className="relative z-10 mx-auto max-w-5xl px-4 py-20 text-center sm:px-6 sm:py-28 lg:px-8">
          <motion.p
            className="mb-4 text-sm font-bold uppercase tracking-[0.24em] text-[#F6BF58]"
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            Resources
          </motion.p>
          <motion.h1
            className="text-3xl font-bold leading-tight text-white sm:text-4xl lg:text-5xl"
            style={{ fontFamily: "'Playfair Display', serif" }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            data-testid="page-title"
          >
            Data Source Statement
          </motion.h1>
          <motion.div
            className="mx-auto mt-6 h-1 w-16 bg-[#F6BF58]"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          />
        </div>
      </section>

      <main className="py-12 sm:py-16">
        <motion.article
          className="prose prose-lg mx-auto max-w-4xl px-4 prose-p:leading-relaxed prose-p:text-slate-700 sm:px-6 lg:px-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.15 }}
          data-testid="page-content"
        >
          <p>
            Secure the Vote Maryland (SecuretheVoteMD) obtains official Maryland voter registration data directly from the State, as permitted under Maryland law. Specifically, Maryland Election Law § 3-506 authorizes the State Board of Elections to provide copies of the statewide voter registration list to applicants, subject to certain conditions and permitted uses.
          </p>
          <p>
            The data used in our analysis is therefore drawn from the same official voter registration records maintained and relied upon by election officials to administer elections and conduct voter list maintenance.
          </p>
          <p>
            Our work does not rely on speculation or unofficial sources. Rather, we organize, review, and cross-reference this official voter file with other publicly available records (such as death records and address data) to identify entries that may warrant further review.
          </p>
          <p>
            Accordingly, the information presented in our reports is based on actual data contained within the State’s voter rolls. These findings are not allegations, but data-driven observations derived from official records and supported by reasonable verification methods.
          </p>
          <p>
            SecuretheVoteMD does not make final determinations regarding voter eligibility. All conclusions and actions remain exclusively within the authority of election officials, in accordance with applicable law.
          </p>
        </motion.article>
      </main>

      <Footer config={STATIC_FOOTER} />
    </div>
  );
};

export default DataSourceStatementPage;
